<template>
  <div class="inonf">
    <!-- {{getwayuuid}} -->
    <div class="box_info">
      <div class="left">
        <div class="title_fend">现场状态：</div>
        <div class="_left_info">
          <!-- <img src="@/assets/img/guanbi.png" alt v-if="false" />
          <img src="@/assets/img/kaiqi.png" alt v-else />-->
          <!-- <p></p> -->
          <el-link :type="flag == 0?'primary':'success'">
            <span style="font-size:18px">{{flag == 0 ? '自动' : '手动'}}</span>
          </el-link>
        </div>
      </div>
      <div class="rigth">
        <div class="bent">
          <el-button type="primary" size="mini">刷新状态</el-button>
        </div>
        <div class="titile_rizhi" @click="caozuo_Fnt">操作日志</div>
      </div>
    </div>
    <!-- 数据表格 -->
    <el-table
      :data="infoTableList"
      style="width: 100%"
      :row-class-name="tableRowClassName"
      border
      :header-cell-style="{ background: '#eef1f6', color: '#606266',textAlign: 'center' }"
    >
      <el-table-column prop="electricname" label="设备名称" align="center"></el-table-column>
      <el-table-column prop="name" label="开关控制" align="center">
        <template slot-scope="{row}">
          <el-switch
            v-if="row.Istrip == 0"
            style="display: block"
            v-model="row.status"
            :disabled="falytable== 1"
            :active-value="'1'"
            :inactive-value="'0'"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="开"
            @change="swithchHnacheng(row)"
            inactive-text="关"
          ></el-switch>
          <div class="box_infoTamp" v-else>
            <!-- 3个按钮 -->
            <div class="bten_warp">
              <!-- {{row.status2}} -->
              <div
                class="btn1"
                v-for="item in row.bentEs"
                :key="item.id"
                @click="handBtne(item,row)"
                :style="{background:getColor(item,row)}"
              >
             
                <img :src="row.status2 + row.uuid == item.id?item.url:item.acitve" alt />
                <p :style="{color:item.id == row.status2 + row.uuid?'#fff':''}">{{item.title}}</p>
              </div>
              <!-- <div class="btn2">
                <img src="@/assets/img/tingzhi.png" alt />
                <p>暂停</p>
              </div>
              <div class="btn3">
                <img src="@/assets/img/xiajiang.png" alt />
                <p>暂停</p>
              </div>-->
            </div>
            <!-- 进度条 -->
            <div class="seep">
              <div class="seep_warp">
                <div class="opton">关帘</div>
                <div class="boxEnds">
                  <el-slider
                    v-model="row.routevalue"
                    :show-tooltip="false"
                    class="sendS"
                    :disabled="falytable== 1"
                  ></el-slider>
                  <div class="piostde" :style="{left:row.routevalue+'%'}">{{row.routevalue}}%</div>
                </div>
                <div class="clon">开帘</div>
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="falytable== 1"
                  @click="handInfo(row)"
                >确认设置</el-button>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="当前状态" align="center">
        <template slot-scope="{row}">
          <!-- {{row.status == 0 ? row.offname : row.onname}} -->
          <img :src="row.status == 0 ? row.closepic:row.openpic" alt width="80" />
        </template>
      </el-table-column>
      <el-table-column prop="address" label="所属通道" align="center">
        <template
          slot-scope="{row}"
        >通道{{row.channelid}}：{{lang_file == 'zh-cn'? row.unittype:row.unittype_en}}</template>
      </el-table-column>
      <el-table-column align="center">
        <template slot-scope="{row}">
          <el-button type="text" @click="handEdirt(row)">查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 日志弹出层 -->
    <el-dialog
      :title="getTitle+'(设备操作日志)'"
      :visible.sync="dialogVisible"
      width="40%"
      :modal="false"
      center
    >
      <div>
        <el-table
          :data="tableCaozuo"
          style="width: 100%"
          :row-class-name="tableRowClassName"
          border
          :header-cell-style="{ background: '#eef1f6', color: '#606266',textAlign: 'center' }"
        >
          <el-table-column prop="addtime" label="日期" align="center"></el-table-column>
          <el-table-column prop="actionname" label="动作" align="center"></el-table-column>
          <el-table-column prop="username" label="操作人" align="center"></el-table-column>
        </el-table>
        <page-helper :page-data="pageData" :total="total" :get-table-list="listCaoZuo"></page-helper>
      </div>
    </el-dialog>
    <!-- 查看详情 -->
    <el-dialog
      title="查看详情"
      :visible.sync="dialogVisibleUser"
      width="50%"
      :modal="false"
      
      :before-close="handleClose"
    >
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <div class="frodData">
          <div class="flends">
            <el-form-item
              label="选择继电器路数:"
              prop="roadid"
              style="padding-bottom: 10px"
              label-width="130px"
            >
              <div class="fleEnd" style="display: flex;">
                <el-select
                  v-model="'第'+ruleForm.roadid+'路'"
                  disabled
                  placeholder="选择继电器路数"
                  style="width: 100%"
                >
                  <el-option
                    :label="item.roadiview"
                    :value="item.roadid"
                    v-for="(item, index) in getDataOption"
                    :key="index"
                  ></el-option>
                </el-select>
                <el-select
                  disabled
                  v-model="'第'+ruleForm.roadid2+'路'"
                  placeholder="选择组合路数"
                  style="width: 100%"
                  v-if="infoData.Istrip == 1"
                >
                  <el-option
                    :label="item.roadiview"
                    :value="item.roadid"
                    v-for="(item, index) in getDataOption"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>
            <el-form-item
              label="选择用电设备:"
              prop="electricuuid"
              style="padding-bottom: 10px"
              label-width="110px"
            >
              <el-select
                v-model="ruleForm.electricuuid"
                placeholder="选择用电设备"
                style="width: 100%"
                @change="changConfing"
              >
                <el-option
                  :label="item.name"
                  :value="item.uuid"
                  v-for="item in confingOption"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item
            label="选择关联通道:"
            prop="channelid"
            style="padding-bottom: 10px"
            label-width="130px"
          >
            <el-select
              v-model="ruleForm.channelid"
              placeholder="选择关联通道"
              style="width: 100%"
              @change="handChange"
            >
              <el-option
                v-for="item in optioneChendId"
                :label="'通道' + item.channelid + ':' + item.lable"
                :value="item.channelid"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- 继电器控制阈值 -->
        <h3 class="titleInfo">继电器控制阈值</h3>
        <!-- 针对多个参数 -->
        <div class="jdq_warp" v-if="infoData.Istrip == 1">
          <el-form-item :label="infoData.onname + ':'" prop="onvalue" style="padding-bottom: 10px">
            <el-input v-model="ruleForm.onvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + ':'"
            prop="offvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.offvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.onname + '1' + ':'"
            prop="onvalue1"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.onvalue2" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + '1' + ':'"
            prop="offvalue1"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.offvalue2" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
        </div>
        <!-- 一个参数 -->
        <div class="jdq_warp" v-if="infoData.Istrip == 0">
          <el-form-item :label="infoData.onname + ':'" prop="onvalue" style="padding-bottom: 10px">
            <el-input v-model="ruleForm.onvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
          <el-form-item
            :label="infoData.offname + ':'"
            prop="offvalue"
            style="padding-bottom: 10px"
          >
            <el-input v-model="ruleForm.offvalue" style="width: 80%"></el-input>
            {{ unitFint }}
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
    <!-- 监听uuid -->
    {{handLISTuuid}}
  </div>
</template>

<script>
import {
  swithchNameInfo,
  CaoZuoRiList,
  EditHnadList,
  CamanetSet,
  wangGuan_sun,
  xingListBing
} from "@/network/lineRequest";
import { listwgtd } from "@/network/index";
import PageHelper from "@/components/common/PageHelper";
export default {
  components: {
    PageHelper,
  },
  props: {
    infoTableList: {
      type: Array,
      default: [],
    },
    falytable: {
      type: String,
      default: "",
    },
    getwayuuid: {
      type: String,
      default: "",
    },
    getTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      getDataOption: [],
      flag: this.falytable,
      handUUid: "",
      optioneChendId: [],
      infoData: {}, //电子设备的信息
      ruleForm: {
        roadid: "",
        channelid: "",
        channel_uuid: "", //所属通道UUID
        sensingunit_uuid: "", //所属传感单元UUID
        onvalue: "", //系和值
        offvalue: "", //断开至
        electricuuid: "", //关联设备id
        gateway_uuid: "",
      },
      unitFint: "℃",
      dialogVisibleUser: false,
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 20, //数据   pagesize几条数据
      },
      confingOption: [],
      total: null,
      lang_file: sessionStorage.getItem("lang_file"),
      seetVlue: null,
      value2: "",
      dialogVisible: false,
      //控制按钮
      currindex: 0,
      tableCaozuo: [],
    };
  },
  watch: {
    getwayuuid(newVlue) {
      // console.log(newVlue);
    },
  },
  created() {},
  mounted() {
    //
    this.confingList();
  },
  computed: {
    handLISTuuid() {
      // console.log();
      this.handUUid = this.getwayuuid;
      this.chandindChend();
    },
  },
  methods: {
    getColor(item,row){
      // console.log(item.id);

      return item.id == row.status2 + row.uuid ? '#0e5dd1':''
    },
        // 控制
   async handBtne(index,row) {
    //  console.log(index.uids);
     
       row.status2 =index.uids//给唯一值
       const { code, data, msg } = await swithchNameInfo({
        uuid:row.uuid,
        status2:index.status2,
        ismanual:row.ismanual,
        status:index.status,
      });
      if (code) {
        this.$message.success(msg);
        return;
      }
      this.$message.error(msg);
    },
    // 确认设置
    async handInfo(e) {
      const { code, data, msg } = await xingListBing({
        uuid: e.uuid,
        routevalue: e.routevalue,
      });
      if (code) {
        this.$message.success(msg);

        return;
      }
      this.$message.error(msg);
    },
    async getUiindList() {
      const { code, data, msg } = await wangGuan_sun({
        gateway_uuid: this.gatewayuuid,
      });
      // console.log(data);
      if (code) {
        this.getDataOption = data;
      }
    },
    // 选择用电设备
    async confingList() {
      const { code, data, msg } = await CamanetSet({});
      if (code) {
        this.confingOption = data;
      }
    },
    async chandindChend() {
      // 获取通道号
      this.optioneChendId = [];
      const { code, data, msg } = await listwgtd(this.handUUid, 1, 32);

      if (code) {
        this.confingList(); //获取电子设备
        data.list.forEach((item) => {
          item.lable =
            this.lang_file == "zh-cn" ? item.unittype : item.unittype_en;
          this.optioneChendId.push(item);
        });

        // console.log( this.optioneChendId);
      }
    },
    // 查看详情
    handEdirt(row) {
      this.ruleForm = { ...row };
      this.infoData = { ...row };
      this.chandindChend();
      this.dialogVisibleUser = true;
    },
    // 获取电子设备的信息
    changConfing(e) {
      let indexFon = this.confingOption.findIndex((item) => item.uuid == e);
      this.infoData = this.confingOption[indexFon];
      this.ruleForm.electricuuid = this.confingOption[indexFon].uuid; //关联设备uuid
    },
    // 关闭按钮
    handleClose(done) {
      done();

      // this.handListn();
    },
    // 确定按钮
    handConfing() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const { code, data, msg } = await EditHnadList(this.ruleForm);
          if (code) {
            this.$message.success(msg);
            this.handListn();
            this.getTable();
            this.dialogVisible = false;
            return;
          }
          this.$message.error(msg);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    hiendClick() {
      this.dialogVisibleUser = false;
      // this.handListn();
    },
    // 获取通道号单位
    handChange(e) {
      let indexFon = this.optioneChendId.findIndex(
        (item) => item.channelid == e
      );
      this.unitFint =
        this.lang_file == "zh-cn"
          ? this.optioneChendId[indexFon].unit
          : this.optioneChendId[indexFon].unit_en;
      this.ruleForm.channel_uuid = this.optioneChendId[indexFon].uuid; //所属通道UUID
      this.ruleForm.sensingunit_uuid = this.optioneChendId[
        indexFon
      ].sensingunit_uuid; //所属传感单元UUID
    },
    // 操作日志
    async listCaoZuo(uuid) {
      this.pageData.gateway_uuid = uuid;
      const { code, data, msg } = await CaoZuoRiList(this.pageData);
      if (code) {
        this.tableCaozuo = data.list;
        this.total = Number(data.pagelist[0].allrow);
      }
    },
    // 操作人
    caozuo_Fnt() {
      this.listCaoZuo(this.getwayuuid);
      this.dialogVisible = true;
    },
    // 监听开关的状态
    async swithchHnacheng(e) {
      const { code, data, msg } = await swithchNameInfo({
        uuid: e.uuid,
        status: e.status,
        ismanual: e.ismanual,
      });
      if (code) {
        this.$message.success(msg);

        return;
      }
      this.$message.error(msg);
    },

    //   斑马线
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
  },
};
</script>

<style scoped lang="less">
.inonf {
  .box_infoTamp {
    .bten_warp {
      display: flex;
      justify-content: center;
      .btn1 {
        width: 44px;
        cursor: pointer;
        height: 44px;
        background: #fff;
        text-align: center;
        margin: 0 10px;
        border-radius: 27px;
        img {
          width: 20px;
          margin: 0 auto;
          height: 20px;
          display: block;
          margin-top: 2px;
          text-align: center;
        }
        p {
          height: 10px;
          font-size: 8px;
          // color: #fff;
        }
      }
      // .btn2 {
      //   width: 44px;
      //   height: 44px;
      //   background: #fff;
      //   text-align: center;
      //     cursor: pointer;
      //   border-radius: 27px;
      //     margin: 0 10px;
      //   img {
      //     width: 20px;
      //     margin: 0 auto;
      //     height: 20px;
      //     display: block;
      //     text-align: center;
      //     margin-top: 2px;
      //   }
      //   p {
      //     height: 10px;
      //     font-size: 8px;
      //     color: #666666;
      //   }
      // }
      // .btn3 {
      //   width: 44px;
      //   height: 44px;
      //   background: #fff;
      //   text-align: center;
      //   border-radius: 27px;
      //     cursor: pointer;
      //   img {
      //     width: 20px;
      //     margin: 0 auto;
      //     height: 20px;
      //     display: block;
      //     text-align: center;
      //     margin-top: 2px;
      //   }
      //   p {
      //     height: 10px;
      //     font-size: 8px;
      //     color: #666666;
      //   }
      // }
    }
  }
  .seep_warp {
    display: flex;
    align-items: center;
    padding: 20px 0;
    // 滑块样式
    .boxEnds {
      position: relative;
      width: 80%;
      margin: 0 auto;
      .piostde {
        position: absolute;
        margin-left: -16px;
        text-align: center;
        bottom: 30px;
        width: 34px;
      }
    }
    .clon,
    .opton {
      width: 50px;
      text-align: center;
    }
  }
  .box_info {
    display: flex;
    justify-content: space-between;
    .left {
      // width: 500px;
      display: flex;
      // align-items: center;
      .title_fend {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
      }
      ._left_info {
        display: flex;
        //  padding: 0 10px;
        //  width: 200px;
      }
    }

    .rigth {
      display: flex;
      align-items: center;
      .bent {
        padding: 0 10px;
      }
      .titile_rizhi {
        font-weight: 500;
        text-decoration: underline;
        color: #3399ff;
        cursor: pointer;
      }
    }
    .el-switch {
      height: 30px i !important;
    }
  }
  .frodData {
    // width: 500px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .flends {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .titleInfo {
    text-align: center;
  }
  .el_elbles {
    text-align: center;
    padding: 30px 0;
  }
  .jdq_warp {
    background: #f8f8f8;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    input[type="text"] {
      border: none;
    }
  }
}
</style>
